export default {"src":"/_next/static/media/number1--salmon.74940906.svg","height":44,"width":13,"blurWidth":0,"blurHeight":0};